module.exports = __webpack_public_path__ + "img/iOS.d6710256.svg";